<template>
  <v-app>

    <Navigation title="Pick"></Navigation>

    <v-content app>

      <v-container height="100%" fluid>

        <v-row v-if="openPickItems.length <= 0 && currentPickFinished === false">
          <v-col cols="12" sm="12">
              <v-card class="elevation-0">
                <v-alert height="60vh" class="d-flex justify-center" elevation="0">Kein Pick ausgewählt</v-alert>
              </v-card>
          </v-col>
        </v-row>

        <v-row v-if="openPickItems.length <= 0 && currentPickFinished === true">
          <v-col cols="12" sm="12">
              <v-card class="elevation-3">
                <v-card-title>Alle Items wurden gepickt</v-card-title>
                <v-btn @click.stop="submitPick()" class="mt-4" x-large color="#faa619" dark width="100%">Pick Abschließen</v-btn>
              </v-card>
          </v-col>
        </v-row>

        <v-row height="100%" v-if="openPickItems.length > 0 && currentPickFinished === false">

          <v-col cols="12" sm="12" md="4" class="order-md-0 order-sm-1">
            <v-card class="elevation-3" tile overflows>

              <v-tabs background-color="white" color="#faa619" grow>
                
                <v-tab>Offen ({{openPickItems.length}})</v-tab>
                <v-tab>Gepickt ({{donePickItems.length}})</v-tab>

                <v-tab-item>
                  <v-list three-line style="overflow: auto;" height="70vh">
                    <v-list-item v-for="(openPickItem, index) in openPickItems" :key="index">
                      <v-list-item-avatar>
                        <v-img :src="openPickItem.image"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title><strong>{{openPickItem.qty}} x {{openPickItem.name}}</strong></v-list-item-title>
                        <v-list-item-subtitle>Lagerplatz: {{openPickItem.bin_name}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>

                 <v-tab-item>
                  <v-list three-line style="overflow: auto;" height="70vh">
                    <v-list-item v-for="(donePickItem, index) in donePickItems" :key="index" @click="updateItem(donePickItem.id)">
                      <v-list-item-avatar>
                        <v-img :src="donePickItem.image"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title><strong>{{donePickItem.qty}} x {{donePickItem.name}}</strong></v-list-item-title>
                        <v-list-item-subtitle>Lagerplatz: {{donePickItem.bin_name}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
              </v-tab-item>
              </v-tabs>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="8" class="order-md-1 order-xs-0">
            <v-card class="elevation-3" tile v-if="currentPick">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-card-title class="pt-0">{{currentPick.name}}</v-card-title>
                  <v-card-subtitle style="font-weight: light;">Pickliste: <b class="ml-1">{{currentPickPixiId}} | Artikel {{currentPickCount + 1}} von {{openPickItems.length + donePickItems.length}}</b></v-card-subtitle>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-card class="elevation-0" tile>
                    <v-img contain width="100%" :src="currentPick.image"></v-img>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-list subheader>
                    <v-subheader style="color: #ff9117; font-weight: bold;">Lagerplatz</v-subheader>
                    <v-list-item>
                      <v-list-item-title style="font-size: 30px; font-weight: bold;">{{currentPick.bin_name}}</v-list-item-title>
                    </v-list-item>
                    <v-subheader style="color: #ff9117; font-weight: bold;">Barcode</v-subheader>
                    <v-list-item>
                      <v-list-item-title style="font-size: 30px; font-weight: bold;">{{currentPick.ean}}</v-list-item-title>
                    </v-list-item>
                    <v-subheader style="color: #ff9117; font-weight: bold;">Menge</v-subheader>
                    <v-list-item>
                      <v-list-item-title style="font-size: 30px; font-weight: bold;">{{currentPick.qty}} Stück</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <v-btn tile class="mt-4" @click.stop="reportMissingCount(currentPick.id)" x-large dark color="#323232" width="100%">Fehlbestand melden</v-btn>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <v-btn tile class="mt-4" @click.stop="pickItem(currentPick.id, currentPick.qty)" x-large color="#faa619" dark width="100%">Picken!</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="dialog.open" max-width="400">
        <v-card>
          <v-card-title>{{dialog.title}}</v-card-title>
          <v-card-text>{{dialog.text}}</v-card-text>
          <v-card-actions>
            <v-btn color="#191919" text @click="dialog.open = false">Nein</v-btn>
            <v-spacer />
            <v-btn color="#faa619" text @click="dialog.action()">Ja</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="missingCountDialog.open" max-width="400">
        <v-card>
          <v-card-title>{{missingCountDialog.title}}</v-card-title>
          <v-card-text>{{missingCountDialog.text}}</v-card-text>
          <v-text-field class="pl-5 pr-5" v-model="missingCountDialog.inputValue" type="number" label="Anzahl"></v-text-field>
          <v-card-actions>
            <v-btn color="#191919" text @click="missingCountDialog.open = false">Abbruch</v-btn>
            <v-spacer />
            <v-btn color="#faa619" text @click="missingCountDialog.action()">Setzen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-content>
    <BottomNavigation activeBtn="pick"></BottomNavigation>
  </v-app>
</template>

<script>
import Navigation from "../components/Navigation";
import BottomNavigation from "../components/BottomNavigation";
import { mapState } from "vuex";
import picklistService from '../services/picklistService';

export default {
  name: "Pick",
  data() {
    return {
      allItemsPicked: false,
      pick: {
        id: "",
        item: null
      },
      dialog: {
        open: false,
        title: "",
        text: "",
      },
      missingCountDialog: {
        open: false,
        title: "",
        text: "",
        inputValue: 1,
      },
      pickedItem: {
        id: "",
        quantity: 0,
        missingItems: 0,
      }
    };
  },
  components: {
    Navigation,
    BottomNavigation
  },
  computed: mapState({
    currentPickId: state => state.pick.id,
    currentPickPixiId: state => state.pick.pixi_id,
    allPickItems: state => state.pick.items,
    openPickItems: state => state.pick.open,
    donePickItems: state => state.pick.done,
    currentPick : state => state.pick.current,
    currentPickCount: state => state.pick.count,
    currentPickFinished: state => state.pick.isFinished,
  }),
  methods: {

    pickItem(id, qty) {
      this.pickedItem.id = id;
      this.pickedItem.quantity = qty;
      this.pickedItem.missingItems = 0;

      if(qty > 1) {
        this.dialog.open = true;
        this.dialog.title = `Haben Sie wirklich ${qty} gepickt?`;
        this.dialog.text = "Bitte bestätigen Sie ihre Eingabe";
        this.dialog.action = this.confirmPickItem;
      } else {
        this.confirmPickItem();
      }
    },

    updateItem(id) {
      // get item to update
      const itemToUpdate = this.donePickItems.find(donePickItem => donePickItem.id === id);
      
      // set item to update

    },

    confirmPickItem() {
      this.dialog.open = false;
      this.setPick();
    },

    reportMissingCount(id) {
      this.pickedItem.id = id;
      this.pickedItem.quantity = 0;
      this.missingCountDialog.open = true;
      this.missingCountDialog.title = "Fehlbestand eintragen";
      this.missingCountDialog.text = "Tragen sie die Anzahl in den unterem Eingabefeld ein, es sind nur Zahlen erlaubt.";
      this.missingCountDialog.action = this.confirmReportMissingCount;
    },

    confirmReportMissingCount() {
      this.missingCountDialog.open = false;
      this.pickedItem.missingItems = parseInt(this.missingCountDialog.inputValue);
      this.setPick();
    },

    setPick() {

      const pickItemsAll = this.allPickItems;
      const donePickItems = this.donePickItems;
      const openPickItems = this.openPickItems;

      const indexOfCurrentItem = openPickItems.map(openPickItem => openPickItem.id).indexOf(this.pickedItem.id);
      const mappedPicks = pickItemsAll.map(pickItem => {
        return pickItem.id;
      });
      const countIndex = mappedPicks.indexOf(this.pickedItem.id);

      // save current pick as done
      this.donePickItems.push({
        id: this.pickedItem.id,
        count_picked: this.pickedItem.quantity,
        count_missing: this.pickedItem.missingItems,
      });
      

      // delete current pick from open picks
      this.openPickItems.splice(indexOfCurrentItem, 1);

      this.$store.dispatch("setCurrentPickStatus", {
        open: this.openPickItems,
        done: this.donePickItems,
        pick: this.openPickItems.length >= 1 ? this.openPickItems[0] : {},
        count: countIndex + 1,
        isFinished: this.openPickItems.length <= 0,
      });

      // reset 
      this.pickedItem.missingItems = 0;
      this.missingCountDialog.inputValue = 1;
    },

    submitPick() {
      const that = this;
      const id = this.currentPickId;
      const submitPicklistItems = this.donePickItems.map(donePickItem => ({
        id: donePickItem.id,
        count_picked: donePickItem.count_picked,
        count_missing: donePickItem.count_missing,
      }));
      console.log("done picks");
      console.log(this.donePickItems);
      console.log("submit:");
      console.log(submitPicklistItems);
      picklistService.finishFullPick(submitPicklistItems)
      .then((response) => {
        if(response.count_updated === this.donePickItems.length) {
          picklistService.endPick(id)
            .then(() => {
              that.$router.push("/");
              picklistService.picklist();
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.pick-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pick-actions {
  flex: 1;
}

.pick-image > img {
  width: 100%;
}
</style>